/**
 * Sound utilities for UI feedback
 * Enhanced with Gachimuchi flavor
 */

// Import audio files so Bun can bundle them properly
import clickSound from '@/assets/audio/pull-up-our-pants-made-with-Voicemod.mp3';
import successSound from '@/assets/audio/will-you-show-me_-meme-made-with-Voicemod.mp3';
import applauseSound from '@/assets/audio/Dangeon Master Boy Next Door Gachi ｜ Данжен Мастер Бой Некст Дор Гачи.mp3';
import slapSound from '@/assets/audio/slap.mp3';
import bossSound from '@/assets/audio/ill-show-you-whose-boss-of-this-gym.mp3';

const sounds = {
  click: clickSound,
  success: successSound,
  applause: applauseSound,
  slap: slapSound,
  boss: bossSound
};

// Pre-create audio elements to avoid garbage collection issues
const audioCache = new Map<string, HTMLAudioElement>();

function getAudio(path: string): HTMLAudioElement {
  if (!audioCache.has(path)) {
    const audio = new Audio(path);
    audio.preload = 'auto';
    audioCache.set(path, audio);
  }
  return audioCache.get(path)!;
}

/**
 * Play a specific sound from the library
 */
function playSound(path: string, volume: number = 0.5): void {
  try {
    const audio = getAudio(path);
    audio.volume = volume;
    audio.currentTime = 0; // Reset to start
    audio.play().catch(e => console.log("Sound play prevented:", e));
  } catch (error) {
    console.error("Error playing sound:", error);
  }
}

/**
 * Play a subtle click sound for UI interactions
 */
export function playClickSound(): void {
  playSound(sounds.click, 0.4);
}

/**
 * Play a success sound for positive actions
 */
export function playSuccessSound(): void {
  playSound(sounds.success, 0.6);
}

/**
 * Play an applause sound for events
 */
export function playApplauseSound(): void {
  playSound(sounds.applause, 0.5);
}

/**
 * Play the classic Gachi slap
 */
export function playSlapSound(): void {
  playSound(sounds.slap, 0.7);
}

/**
 * Show them who is the boss of this gym
 */
export function playBossSound(): void {
  playSound(sounds.boss, 0.8);
}
